import React from "react";

import Container from "../../components/Shared/Container";

import { useHistory } from "react-router";

import START_SCREEN from '../../assets/start_screen.png';
import START_SCREEN_SAFARI from '../../assets/start_screen_safari.png';

const Start = () => {
	const history = useHistory();
	const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
		navigator.userAgent &&
		navigator.userAgent.indexOf('CriOS') === -1 &&
		navigator.userAgent.indexOf('FxiOS') === -1;

	return (
		isSafari ?
			(
				<a href={"https://umed.pl/"}>
					<Container
						justify={'center'} backgroundImage={START_SCREEN_SAFARI}
						backrgroundColor={'white'}
						cursor={'pointer'}
						align={'center'}
					/>
				</a>
			) :
			<Container
				justify={'center'} backgroundImage={START_SCREEN}
				onClick={() => history.push('/movie')}
				backrgroundColor={'white'}
				cursor={'pointer'}
				align={'center'}
			/>
	)
};

export default Start;